import React, { useState, useCallback, useEffect } from 'react'
import {
  SectionWrapper,
  TopHeader,
  PaddedDiv,
  TopSection,
  PaddedDivHome,
  EntityTypeContainer,
  EntityTypeLabel,
  EntityTypeOptions,
  EntityTypeOption,
  CardRowSpaceBetween
} from './Style/style'

import { CheckCircleOutlined, UserOutlined, SendOutlined, FileTextOutlined, ExperimentOutlined, CrownOutlined, TeamOutlined, MailOutlined, FormOutlined, BulbOutlined } from '@ant-design/icons'
import AccountCircleIcon from '../../components/icons/AccountCircleIcon'
import LibraryBooksIcon from '../../components/icons/LibraryBooksIcon'
import CheckboxIcon from '../../components/icons/CheckboxIcon'
import AlarmOnIcon from '../../components/icons/AlarmOnIcon'
import InfoCardsUpdate from '../../components/InfoCardsUpdate/cardDetails'
import { COLORS, ANTD_COLORS } from 'theme'
import { Row, Col, Select, Typography, Spin, Alert, Table, Tabs, Card } from 'antd'

import styled from 'styled-components'
import Button from '../../components/Button'
import CtcSelect from '../../components/CtcSelect'

import ActiveAssessmentTable from './Partials/ActiveAssessmentTable'
import CompletedAssessmentTable from './Partials/CompletedAssessmentTable'
import UnifiedAssessmentTable from './Partials/UnifiedAssessmentTable'
import AssessmentDetails from './Partials/AssessmentDetails'
import StudentsTable from './Partials/AllStudentsTable'
import TpoStudentListTable from './Partials/TpoStudentListTable'
import DiagnosisList from './Partials/DiagnosisList'

import {
  fetchActiveAssessments,
  fetchCompletedAssessments,
  fetchActiveAssessmentCount,
  fetchAssessmentCompletedCount,
  setFilters,
  fetchAssessmentDetails,
  setAssessmentFilters,
  fetchStudentsByStatus,
  fetchAllStudentStatusCounts,
  exportStudentData,
  sendRemindersToStudents,
  resendInvitesToStudents,
  // Import new actions
  getInstituteDomains,
  getInstituteDegrees,
  getInstituteDepartments,
  getInstituteSpecializations,
  setChartFilters,
  clearChartFilters,
  fetchStudentList,
  fetchAssessmentStatesForInstitute,
  getYearOfPassing,
} from './actions'
import { fetchSpecificAssessmentStudentList } from './actions'
import {
  selectActiveAssessments,
  selectActiveAssessmentsPagination,
  selectActiveAssessmentsMetrics,
  selectCompletedAssessments,
  selectCompletedAssessmentsPagination,
  selectCompletedAssessmentsMetrics,
  selectLoadingStatus,
  selectError,
  selectFilters,
  selectActiveAssessmentCount,
  selectAssessmentCompletedCount,
  selectStudentDataSent,
  selectStudentDataPending,
  selectStudentDataInProgress,
  selectStudentDataDroppedOff,
  selectStudentDataCompleted,
  selectStudentDataLoading,
  selectStudentDataPagination,
  selectAssessmentFilters,
  selectSpecificAssessmentStudentList,
  selectSpecificAssessmentStudentListLoading,
  selectSpecificAssessmentStudentListPagination,
} from './selectors'

import {
  PageContainer,
  ErrorContainer,
  LoadingContainer,
} from './Style'
import { useDispatch } from 'react-redux'
import instRequest from 'utils/instRequest'

const { Option } = Select

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
    background: #F5F5F5;
    border-radius: 12px;
    padding: 0;
    box-shadow: none;
    width: 100% !important;
    margin: 0 !important;
  }
  
  .ant-tabs-tab {
    flex: 1 1 0 !important;
    max-width: none !important;
    padding: 16px 0 !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #000 !important;
    text-align: center;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box !important;
    transition: none !important;
    border: none !important;
    margin: 0 !important;
    
    &:hover {
      color: #3D5AFE;
      background: transparent;
    }
    
    &:first-child {
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }
    
    &:last-child {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
    }
    
    &.ant-tabs-tab-active {
      background: #3D5AFE !important;
      border-radius: 12px;
      padding: 16px 0 !important;
      
      &:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
      }
      
      &:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      
      .ant-tabs-tab-btn {
        color: #FFFFFF !important;
        font-weight: 700 !important;
      }
      
      &:hover {
        background: #3D5AFE !important;
        
        .ant-tabs-tab-btn {
          color: #FFFFFF !important;
        }
      }
    }
  }
  
  .ant-tabs-ink-bar {
    display: none;
  }
  
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  
  .ant-tabs-nav-wrap {
    padding: 0 !important;
    width: 100% !important;
  }
  
  .ant-tabs-nav-list {
    gap: 0;
    width: 100% !important;
    flex: 1;
    margin: 0 !important;  // Remove any default margins
  }
  
  // Ensure no extra spacing on the container
  .ant-tabs-content-holder {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .ant-tabs-nav-operations {
    display: none !important;
  }
`


const TabWrapper = styled.div`
  width: 100%;
  padding: 0 20px 0 0;
  margin-bottom: 24px;
  
`

const Assessment = props => {
  // Redux props extraction
  const {
    loading,
    activeAssessmentCount,
    assessmentCompletedCount,
    activeAssessments,
    activeAssessmentsPagination,
    activeAssessmentsMetrics,
    fetchActiveAssessments,
    completedAssessments,
    completedAssessmentsPagination,
    completedAssessmentsMetrics,
    fetchCompletedAssessments,
    filters,
    stateCityPairsActive,
    stateCityPairsCompleted,
    instituteDetails,
    fetchActiveAssessmentCount,
    fetchAssessmentCompletedCount,
    fetchStudentAssessments,  // Add this import
    error,
    chartFilters,
    fetchAssessmentStatesForInstitute,
  } = props
  const dispatch = useDispatch()
  const [activeTable, setActiveTable] = useState('all-assessments')
  const [entityType, setEntityType] = useState('college')
// selectedYear is set only by dropdown or first fetch
const [selectedYear, setSelectedYear] = useState('')
  const [selectedAssessmentFilter, setSelectedAssessmentFilter] = useState('all')
  const [assessmentTypes, setAssessmentTypes] = useState([])

  const [showAssessmentDetails, setShowAssessmentDetails] = useState(false)
  const [selectedAssessment, setSelectedAssessment] = useState(null)

  // NEW: State for filter options and selections
  const [domainOptions, setDomainOptions] = useState([])
  const [degreeOptions, setDegreeOptions] = useState([])
  const [departmentOptions, setDepartmentOptions] = useState([])
  const [specializationOptions, setSpecializationOptions] = useState([])

  const [topLevelDomain, setTopLevelDomain] = useState([])
  const [topLevelDegree, setTopLevelDegree] = useState([])
  const [topLevelDepartment, setTopLevelDepartment] = useState([])
  const [topLevelSpecialization, setTopLevelSpecialization] = useState([])
  const [topLevelPassingYear, setTopLevelPassingYear] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [yearData, setYearData] = useState([])
  const [yearLoaded, setYearLoaded] = useState(false)
  const [showStudentDetails, setShowStudentDetails] = useState(false)
  const [tpoStudentModalVisible, setTpoStudentModalVisible] = useState(false)
  const [studentsList, setStudentsList] = useState([])
  const [studentPage, setStudentPage] = useState(1)
  const [studentSearch, setStudentSearch] = useState('')
  const [studentTotalItems, setStudentTotalItems] = useState(0)
  const [showDiagnosisList, setShowDiagnosisList] = useState(false)


  const fetchYearList = useCallback(async () => {
    const result = await dispatch(getYearOfPassing(props.instituteDetails?.id))
    setYearData(result)
    // Always set default year from fetched list
    if (result && result.length > 0) {
      const currentYear = new Date().getFullYear()
      const hasCurrentYear = result.some(item => item.year == currentYear)
      if (hasCurrentYear) {
        setSelectedYear(currentYear.toString())
      } else {
        const years = result.map(item => parseInt(item.year)).filter(y => !isNaN(y))
        if (years.length > 0) {
          const minYear = Math.min(...years)
          setSelectedYear(minYear.toString())
        }
      }
    }
    setYearLoaded(true)
  }, [props.instituteDetails?.id])

  // Reset yearLoaded and fetch year list when institute changes
  useEffect(() => {
    if (props.instituteDetails?.id) {
      setYearLoaded(false)
      fetchYearList();
    }
  }, [props.instituteDetails?.id])


  const fetchStudentDataList = async () => {
    let result = await dispatch(fetchStudentList(props.instituteDetails?.id, studentPage, studentSearch, selectedYear))
    setStudentsList(result?.data?.data || [])
    setStudentTotalItems(result?.data?.pagination?.totalCount || 0)
  }

  useEffect(() => {
    if (props.instituteDetails?.id && yearLoaded && selectedYear) {
      fetchStudentDataList();
    }
  }, [props.instituteDetails?.id, studentPage, studentSearch, selectedYear, yearLoaded])

  // DEPRECATED: This useEffect used old API with assessmentInstituteMapId
  // AssessmentDetails now handles domain fetching using scheduleId
  // useEffect(() => {
  //   const assessmentId = selectedAssessment?.assessmentInstituteMapId || selectedAssessment?.assessmentId || selectedAssessment?.id
  //   if (assessmentId) {
  //     props.getInstituteDomains(assessmentId).then(data => {
  //       const options = (data || []).map(item => ({ label: item.name, value: item.id }))
  //       setDomainOptions(options)
  //     })
  //   } else {
  //     setDomainOptions([])
  //   }
  // }, [selectedAssessment])

  // Handlers for cascading filters
  const handleDomainChange = async selectedDomains => {
    setTopLevelDomain(selectedDomains)
    setTopLevelDegree([])
    setTopLevelDepartment([])
    setTopLevelSpecialization([])
    setDegreeOptions([])
    setDepartmentOptions([])
    setSpecializationOptions([])

    if (selectedDomains.length > 0 && props.instituteDetails?.id) {
      const domainIds = selectedDomains.map(d => d.value)
      const data = await props.getInstituteDegrees(
        props.instituteDetails.id,
        domainIds
      )
      const options = (data || []).map(item => ({
        label: item.name,
        value: item.id,
      }))
      setDegreeOptions(options)
    }
  }

  const handleDegreeChange = async selectedDegrees => {
    setTopLevelDegree(selectedDegrees)
    setTopLevelDepartment([])
    setTopLevelSpecialization([])
    setDepartmentOptions([])
    setSpecializationOptions([])

    if (selectedDegrees.length > 0 && props.instituteDetails?.id) {
      const degreeIds = selectedDegrees.map(d => d.value)
      const data = await props.getInstituteDepartments(
        props.instituteDetails.id,
        degreeIds
      )
      const options = (data || []).map(item => ({
        label: item.name,
        value: item.id,
      }))
      setDepartmentOptions(options)
    }
  }

  const handleDepartmentChange = async selectedDepartments => {
    setTopLevelDepartment(selectedDepartments)
    setTopLevelSpecialization([])
    setSpecializationOptions([])

    if (selectedDepartments.length > 0 && props.instituteDetails?.id) {
      const departmentIds = selectedDepartments.map(d => d.value)
      const data = await props.getInstituteSpecializations(
        props.instituteDetails.id,
        departmentIds
      )
      const options = (data || []).map(item => ({
        label: item.name,
        value: item.id,
      }))
      setSpecializationOptions(options)
    }
  }

  const currentYear = new Date().getFullYear()
  const passingYears = []

  for (let i = 0; i < 1; i++) {
    passingYears.push({
      id: (currentYear + i).toString(),
      name: (currentYear + i).toString(),
    })
  }

  // KPI data
  const kpiData = [
    {
      text: 'Total Candidates',
      value: completedAssessmentsMetrics?.infoCards?.totalCandidates || 0,
      padding: '16px',
      borderColor: '#BFBFBF',
      isSelected: false,
      marginLeft: '5px',
      textColor: '#3249D7',
      isFirst: true,
      icon: <AccountCircleIcon size={20} />
    },
    {
      text: 'Total Assmts. Sent',
      value: completedAssessmentsMetrics?.infoCards?.totalAssessmentsSent || 0,
      padding: '16px',
      borderColor: '#BFBFBF',
      isSelected: false,
      textColor: '#393939',
      isFirst: false,
      icon: <LibraryBooksIcon size={20} />
    },
    {
      text: 'Total Assmts. Taken',
      value: completedAssessmentsMetrics?.infoCards?.totalAssessmentsTaken || 0,
      padding: '16px',
      borderColor: '#BFBFBF',
      isSelected: false,
      textColor: '#393939',
      isFirst: false,
      icon: <CheckboxIcon size={20} />
    },
    {
      text: 'Total Practice Tests',
      value: completedAssessmentsMetrics?.infoCards?.totalPracticeTests || 0,
      padding: '16px',
      borderColor: '#BFBFBF',
      isSelected: false,
      textColor: '#393939',
      isFirst: false,
      icon: <CheckboxIcon size={20} />
    },
    // {
    //   text: 'Active Plans',
    //   value: '-',
    //   padding: '16px',
    //   borderColor: '#BFBFBF',
    //   isSelected: false,
    //   textColor: '#393939',
    //   isFirst: false,
    //   icon: <AlarmOnIcon size={20} />
    // },
  ]

  const handleYearChange = value => {
    setSelectedYear(value)
  }

  // Debounce function
  const debounce = (fn, delay) => {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  // Create debounced versions of the fetch functions
  const debouncedFetchActiveAssessments = useCallback(
    debounce(params => {
      fetchActiveAssessments &&
        fetchActiveAssessments({ ...params, entityType })
    }, 500),
    [entityType, fetchActiveAssessments]
  )


  // Fetch data on mount
  useEffect(() => {
    if (!yearLoaded || !selectedYear) return

    // Build type_name from current filter selection
    const typeNameMap = { 'all': '' }
    assessmentTypes.forEach(t => {
      const key = t.typeName?.toLowerCase() || t.key
      typeNameMap[key] = t.typeName || key
    })

    const params = {
      entityType,
      instituteId: instituteDetails?.instituteId || instituteDetails?.id,
      passingYear: selectedYear,
      order: 'createdAt',
      sort: 'desc',
      pageNo: 0,
      pageLimit: 10,
      type_name: typeNameMap[selectedAssessmentFilter] !== undefined ? typeNameMap[selectedAssessmentFilter] : '',
    }

    if (!params.instituteId) return

    fetchActiveAssessmentCount && fetchActiveAssessmentCount(params)
    fetchAssessmentCompletedCount && fetchAssessmentCompletedCount(params)

    fetchActiveAssessments && fetchActiveAssessments(params)
  }, [
    instituteDetails,
    fetchActiveAssessments,
    fetchActiveAssessmentCount,
    fetchAssessmentCompletedCount,
    entityType,
    selectedYear,
    yearLoaded,
  ])

  // New Effect for fetching KPI cards data
  useEffect(() => {
    if (instituteDetails?.instituteId && fetchAssessmentStatesForInstitute && yearLoaded && selectedYear) {
      fetchAssessmentStatesForInstitute({
        instituteId: instituteDetails.instituteId,
        passingYear: selectedYear,
      })
    }
  }, [instituteDetails?.instituteId, fetchAssessmentStatesForInstitute, selectedYear, yearLoaded])

  // Fetch assessment types dynamically
  useEffect(() => {
    const fetchAssessmentTypesData = async () => {
      if (!instituteDetails?.instituteId) return
      try {
        const response = await instRequest.get('/institutes/studentListInfo/getAssessmentTypes', {
          params: { instituteId: instituteDetails.instituteId },
        })
        const types = response?.data?.data || []
        setAssessmentTypes(types)
      } catch (error) {
        console.error('Error fetching assessment types:', error)
      }
    }
    fetchAssessmentTypesData()
  }, [instituteDetails?.instituteId])

  // Initialize with "All" filter on first load
  useEffect(() => {
    if (selectedAssessmentFilter === 'all' && instituteDetails?.instituteId && yearLoaded && selectedYear) {
      handleMenuClick('all')
    }
  }, [instituteDetails?.instituteId, yearLoaded, selectedYear])

  // Ensure active table is set when data loads
  useEffect(() => {
    if (!activeTable && (activeAssessments.length > 0 || completedAssessments.length > 0)) {
      setActiveTable('all-assessments')
    }
  }, [activeAssessments, completedAssessments, activeTable])

  const handleMenuClick = (filterType) => {
    setSelectedAssessmentFilter(filterType)

    // Map the menu filter to API type_name (dynamically built)
    const typeNameMap = { 'all': '' }
    assessmentTypes.forEach(t => {
      const key = t.typeName?.toLowerCase() || t.key
      typeNameMap[key] = t.typeName || key
    })

    const params = {
      type_name: typeNameMap[filterType],
      entityType: entityType,
      instituteId: instituteDetails?.instituteId,
    }

    // Fetch both active and completed assessments with the filter
    fetchActiveAssessments &&
      fetchActiveAssessments({
        ...params,
        pageNo: 0,
        pageLimit: 10,
        order: 'createdAt',
        sort: 'desc',
        isTrial: false,
        isSubscribed: false,
        entityType: entityType,
        updateFilters: true,
        passingYear: selectedYear,
      })

    // Set active table to show all assessments
    setActiveTable('all-assessments')
  }



  const handleAssessmentClick = assessment => {
    // Check if this is a diagnosis click
    if (assessment?.isDiagnosis) {
      setSelectedAssessment(assessment)
      setShowDiagnosisList(true)
      setShowAssessmentDetails(false)
      setActiveTable(null)
    } else {
      setSelectedAssessment(assessment)
      setTopLevelPassingYear(selectedYear)
      setShowAssessmentDetails(true)
      setShowDiagnosisList(false)
      setActiveTable(null)
    }
  }

  const handleNavSwitchToDiagnosis = (assessment) => {
    const assessmentDetails = assessment.assessmentDetails || []
    setSelectedAssessment({
      ...assessment,
      isDiagnosis: true,
      assessmentDetails,
      scheduleId: assessment.scheduleId,
      assessmentType: assessment.assessmentType,
      scheduleName: assessment.scheduleName,
    })
    setShowDiagnosisList(true)
    setShowAssessmentDetails(false)
    setActiveTable(null)
  }

  const handleNavSwitchToAssessment = (assessment, detail) => {
    const assessmentDetails = assessment.assessmentDetails || []
    setSelectedAssessment({
      ...assessment,
      ...detail,
      isDiagnosis: false,
      id: detail.assessmentInstituteMapId,
      assessmentInstituteMapId: detail.assessmentInstituteMapId,
      assessmentDetails,
    })
    setTopLevelPassingYear(selectedYear)
    setShowAssessmentDetails(true)
    setShowDiagnosisList(false)
    setActiveTable(null)
  }

  // Assessment menu items for the tabs (dynamically fetched)
  const assessmentMenuItems = [
    {
      key: 'all',
      label: (
        <div style={{ textAlign: 'center', lineHeight: '1.6' }}>
          <div>ALL</div>
        </div>
      ),
    },
    ...assessmentTypes.map(t => ({
      key: t.typeName?.toLowerCase() || t.key,
      label: (
        <div style={{ textAlign: 'center', lineHeight: '1.6' }}>
          <div>{t.typeName || t.label}</div>
        </div>
      ),
    })),
  ]

  const renderYearOptions = () => {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = 0; i < 5; i++) {
      years.push(currentYear - i)
    }
    return years.map(year => (
      <Option key={year} value={year.toString()}>
        {year}
      </Option>
    ))
  }

  const cardClickHandler = (kpi) => {
    if (kpi.text === 'Total Candidates') {
      setTpoStudentModalVisible(!tpoStudentModalVisible)
    }
  }

  if (error) {
    return (
      <PageContainer>
        <ErrorContainer>
          <Alert message="Error" description={error} type="error" showIcon />
        </ErrorContainer>
      </PageContainer>
    )
  }



  return (
    <SectionWrapper column>
      {!showAssessmentDetails && !showDiagnosisList && (
        <>
          {/* Header with Title and Passing Year Dropdown */}
          <TopSection padding="10px 24px 10px 0px">
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                marginBottom: '24px',
              }}
            >
              <TopHeader>Assessment Dashboard</TopHeader>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    marginRight: '12px',
                    whiteSpace: 'nowrap',
                    fontWeight: '600',
                    color: '#000000',
                  }}
                >
                  Passing year
                </div>
                <div>
                  <CtcSelect
                    OptionData={yearData}
                    placeholder="Select passing year"
                    onChange={handleYearChange}
                    value={selectedYear}
                    valueParam="year"
                    nameParam="year"
                    showSearch={false}
                    bordered={true}
                    style={{ minWidth: '180px' }}
                    selectedOptionColor={'#3249D7'}
                  />
                </div>
              </div>
            </div>
          </TopSection>

          {/* KPI Summary Cards */}
          {/* <div style={{ marginBottom: '32px', padding: '0 20px' }}>
            <Row gutter={[20, 16]} justify="space-between"> */}
          <CardRowSpaceBetween spaceBetween>
            {kpiData.map((kpi, index) => (

              <InfoCardsUpdate
                padding={kpi.padding}
                width={'100%'}
                height={'100px'}
                text=""
                IconText={kpi.text}
                value={kpi.value}
                borderColor={`1px solid ${kpi.borderColor}`}
                isClickable={false}
                isSelected={kpi.isSelected}
                backgroundColor={'#ffffff'}
                textColor={kpi.textColor}
                icon={kpi.icon}
                isFirst={kpi.isFirst}
                onClick={() => cardClickHandler(kpi)}
                showStudentDetails={showStudentDetails}
                style={{ cursor: kpi.isFirst ? 'pointer' : 'default' }}
              />

            ))}
          </CardRowSpaceBetween>
        </>
      )}

      {/* Assessment Menu Tabs - Move outside PaddedDiv to align with KPI cards */}
      {!showAssessmentDetails && !showDiagnosisList && (
        <TabWrapper style={{ display: tpoStudentModalVisible ? 'none' : 'block' }}>
          <StyledTabs
            activeKey={selectedAssessmentFilter}
            onChange={handleMenuClick}
            items={assessmentMenuItems}
            size="large"
            type="card"
          />
        </TabWrapper>
      )}

      {tpoStudentModalVisible && (
        <SectionWrapper>
          <TpoStudentListTable
            instituteId={instituteDetails?.instituteId}
            onBack={() => setTpoStudentModalVisible(false)}
            selectedYear={selectedYear}
          />
        </SectionWrapper>
      )}

      {!showStudentDetails && (
        <PaddedDivHome column style={{ display: tpoStudentModalVisible ? 'none' : undefined }}>
          {showDiagnosisList ? (
            <>
              <div style={{ marginBottom: 16 }}>
                <Button.Secondary
                  text="← Back to Assessments"
                  onClick={() => {
                    setShowDiagnosisList(false)
                    setActiveTable('all-assessments')
                    dispatch(clearChartFilters())
                    setTopLevelDomain([])
                    setTopLevelDegree([])
                    setTopLevelDepartment([])
                    setTopLevelSpecialization([])
                    setDegreeOptions([])
                    setDepartmentOptions([])
                    setSpecializationOptions([])
                  }}
                />
              </div>
              <DiagnosisList
                scheduleId={selectedAssessment?.scheduleId}
                latestAssessmentInstituteMapId={selectedAssessment?.latestAssessmentInstituteMapId}
                assessmentType={selectedAssessment?.assessmentType}
                scheduleName={selectedAssessment?.scheduleName}
                passingYear={selectedYear}
                instituteId={instituteDetails?.instituteId || instituteDetails?.id}
                assessmentDetails={selectedAssessment?.assessmentDetails || []}
                onSwitchToAssessment={(detail) => handleNavSwitchToAssessment(selectedAssessment, detail)}
                // Pass filter options
                domainOptionsFromProps={domainOptions}
                degreeOptionsFromProps={degreeOptions}
                departmentOptionsFromProps={departmentOptions}
                specializationOptionsFromProps={specializationOptions}
                // Pass filter values and handlers
                topLevelDomain={topLevelDomain}
                setTopLevelDomain={handleDomainChange}
                topLevelDegree={topLevelDegree}
                setTopLevelDegree={handleDegreeChange}
                topLevelDepartment={topLevelDepartment}
                setTopLevelDepartment={handleDepartmentChange}
                topLevelSpecialization={topLevelSpecialization}
                setTopLevelSpecialization={setTopLevelSpecialization}
              />
            </>
          ) : showAssessmentDetails ? (
            <AssessmentDetails
              assessment={selectedAssessment}
              onClose={() => {
                setShowAssessmentDetails(false)
                setActiveTable('all-assessments')
              }}
              instituteDetails={instituteDetails}
              entityType={entityType}
              onSwitchToDiagnosis={() => handleNavSwitchToDiagnosis(selectedAssessment)}
              // Pass down filter data and handlers
              domainOptions={domainOptions}
              degreeOptions={degreeOptions}
              departmentOptions={departmentOptions}
              specializationOptions={specializationOptions}
              topLevelDomain={topLevelDomain}
              setTopLevelDomain={handleDomainChange}
              topLevelDegree={topLevelDegree}
              setTopLevelDegree={handleDegreeChange}
              topLevelDepartment={topLevelDepartment}
              setTopLevelDepartment={handleDepartmentChange}
              topLevelSpecialization={topLevelSpecialization}
              setTopLevelSpecialization={setTopLevelSpecialization}
              topLevelPassingYear={topLevelPassingYear}
              setTopLevelPassingYear={setTopLevelPassingYear}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              // Pass Redux state and actions as props
              fetchAssessmentDetails={props.fetchAssessmentDetails}
              studentDataLoading={props.studentDataLoading}
              studentDataPagination={props.studentDataPagination}

              // Keep existing props to not break other functionality
              loading={loading}
              assessmentFilters={props.assessmentFilters}
              setAssessmentFilters={props.setAssessmentFilters}
              fetchStudentsByStatus={props.fetchStudentsByStatus}
              // Fix: Pass the missing action prop
              fetchSpecificAssessmentStudentList={props.fetchSpecificAssessmentStudentList}

              fetchAllStudentStatusCounts={props.fetchAllStudentStatusCounts}
              studentDataSent={props.studentDataSent}
              studentDataPending={props.studentDataPending}
              studentDataInProgress={props.studentDataInProgress}
              studentDataDroppedOff={props.studentDataDroppedOff}
              studentDataCompleted={props.studentDataCompleted}
              exportStudentData={props.exportStudentData}
              sendRemindersToStudents={props.sendRemindersToStudents}
              resendInvitesToStudents={props.resendInvitesToStudents}

              // Chart filter props
              chartFilters={chartFilters}
              setChartFilters={setChartFilters}
              clearChartFilters={clearChartFilters}
            />
          ) : (
            <>
              {/* Table Section */}
              {activeTable === 'all-assessments' && (
                <UnifiedAssessmentTable
                  activeAssessments={activeAssessments}
                  completedAssessments={completedAssessments}
                  loading={loading}
                  stateCityPairs={stateCityPairsActive}
                  onAssessmentClick={handleAssessmentClick}
                  filters={filters}
                  activePage={activeAssessmentsPagination?.page || 0}
                  completedPage={completedAssessmentsPagination?.page || 0}
                  activeLimit={activeAssessmentsPagination?.limit || 10}
                  completedLimit={completedAssessmentsPagination?.limit || 10}
                  activeTotalItems={activeAssessmentsPagination?.totalItems || 0}
                  completedTotalItems={completedAssessmentsPagination?.totalItems || 0}
                  activeMetrics={activeAssessmentsMetrics}
                  completedMetrics={completedAssessmentsMetrics}
                  entityType={entityType}
                  instituteId={instituteDetails?.instituteId || instituteDetails?.id}
                  passingYear={selectedYear}
                  onPageChange={page => {
                    const typeNameMap = {
                      'all': '',
                      'communication': 'communication',
                      'cognitive': 'aptitude',
                      'behavioral': 'behavior',
                      'technical-mcq': 'technical_mcq',
                      'technical-coding': 'technical_coding',
                    }

                    // Update both active and completed assessments
                    fetchActiveAssessments &&
                      fetchActiveAssessments({
                        ...filters,
                        pageNo: page,
                        pageLimit: activeAssessmentsPagination?.limit || 10,
                        pageOnly: true,
                        type_name: typeNameMap[selectedAssessmentFilter] || filters.type_name,
                        entityType,
                        instituteId: instituteDetails?.instituteId,
                        passingYear: selectedYear,
                      })
                  }}
                  onFilterChange={newFilters => {
                    const typeNameMap = {
                      'all': '',
                      'communication': 'communication',
                      'cognitive': 'aptitude',
                      'behavioral': 'behavior',
                      'technical-mcq': 'technical_mcq',
                      'technical-coding': 'technical_coding',
                    }

                    const updatedFilters = {
                      ...filters,
                      ...newFilters,
                      type_name: typeNameMap[selectedAssessmentFilter] || '',
                      states: newFilters.states || filters?.states,
                      cities: newFilters.cities || filters?.cities,
                      pageNo: 0,
                      pageLimit: activeAssessmentsPagination?.limit || 10,
                      updateFilters: true,
                      entityType,
                      instituteId: instituteDetails?.instituteId,
                      passingYear: selectedYear,
                    }
                    debouncedFetchActiveAssessments(updatedFilters)
                  }}
                />
              )}
            </>
          )}
        </PaddedDivHome>
      )}
      {showStudentDetails && (
        <StudentsTable
          loading={false}
          students={studentsList}
          studentPage={studentPage}
          setStudentPage={setStudentPage}
          studentSearch={studentSearch}
          setStudentSearch={setStudentSearch}
          // statusType={statusType}
          totalItems={studentTotalItems}
        // limit={limit}
        // page={page}
        // onPageChange={onPageChange}
        // filterValues={filterValues}
        // onClearFilters={onClearFilters}
        // assessmentId={assessmentId}
        // exportStudentData={exportStudentData}
        // sendRemindersToStudents={sendRemindersToStudents}
        // resendInvitesToStudents={resendInvitesToStudents}
        // entityType={entityType}
        // allowProctoring={allowProctoring}
        // assessmentType={assessmentType}
        />
      )}
    </SectionWrapper>
  )
}

import { connect } from 'react-redux'

const mapStateToProps = state => ({
  loading: selectLoadingStatus(state),
  error: selectError(state),
  filters: selectFilters(state),
  activeAssessmentCount: selectActiveAssessmentCount(state),
  assessmentCompletedCount: selectAssessmentCompletedCount(state),
  activeAssessments: selectActiveAssessments(state),
  activeAssessmentsPagination: selectActiveAssessmentsPagination(state),
  activeAssessmentsMetrics: selectActiveAssessmentsMetrics(state),
  completedAssessments: selectCompletedAssessments(state),
  completedAssessmentsPagination: selectCompletedAssessmentsPagination(state),
  completedAssessmentsMetrics: selectCompletedAssessmentsMetrics(state),
  instituteDetails: state.auth.instituteDetails,
  // REMOVE stateCityPairsActive, stateCityPairsCompleted, studentData
  studentDataSent: selectStudentDataSent(state),
  studentDataPending: selectStudentDataPending(state),
  studentDataInProgress: selectStudentDataInProgress(state),
  studentDataDroppedOff: selectStudentDataDroppedOff(state),
  studentDataCompleted: selectStudentDataCompleted(state),
  studentDataLoading: selectStudentDataLoading(state),
  studentDataPagination: selectStudentDataPagination(state),
  assessmentFilters: selectAssessmentFilters(state),
  // New selectors for specific assessment student list
  specificAssessmentStudentList: selectSpecificAssessmentStudentList(state),
  specificAssessmentStudentListLoading: selectSpecificAssessmentStudentListLoading(state),
  specificAssessmentStudentListPagination: selectSpecificAssessmentStudentListPagination(state),
})

const mapDispatchToProps = {
  fetchActiveAssessments,
  fetchCompletedAssessments,
  fetchActiveAssessmentCount,
  fetchAssessmentCompletedCount,
  setFilters,
  fetchAssessmentDetails,
  setAssessmentFilters,
  fetchStudentsByStatus,
  fetchAllStudentStatusCounts,
  exportStudentData,
  sendRemindersToStudents,
  resendInvitesToStudents,
  // Add new actions
  getInstituteDomains,
  getInstituteDegrees,
  getInstituteDepartments,
  getInstituteSpecializations,
  fetchAssessmentStatesForInstitute,
  fetchSpecificAssessmentStudentList,
}

// Change this line:
// export default Assessment
// To this:
export default connect(mapStateToProps, mapDispatchToProps)(Assessment)
